import { useI18n } from "@jog/react-components"
import { typedBoolean } from "@jog/shared"
import { JoggStore } from "@jog/types"

import { CheckMark } from "../Icon/CheckMark"
import { Opening } from "../JcStore/Opening"

const CheckMarkItem = ({ text }: { text: string }) => (
    <div className="flex items-start">
        <CheckMark width={16} height={16} strokeWidth={4} className="my-1 mr-2 shrink-0 text-green-main" />
        <span className="leading-6">{text}</span>
    </div>
)

const CheckMarks = ({
    store: { hasKids, hasTailor, hasCoffee, hasDHLServicePoint },
    className,
}: {
    className?: string
    store: JoggStore
}) => {
    const { $t } = useI18n()
    return (
        <div className={className}>
            <CheckMarkItem text={$t("Women & men collectie")} />
            {hasKids && <CheckMarkItem text={$t("Boys & girls collection")} />}
            {hasTailor && <CheckMarkItem text={$t("Jeans workshop: have your jeans entertained for free!")} />}
            {hasCoffee && <CheckMarkItem text={$t("Coffee corner")} />}
            {hasDHLServicePoint && <CheckMarkItem text={$t("DHL Service Point")} />}
        </div>
    )
}

export const ActiveStore = ({ activeStore }: { activeStore: JoggStore }) => {
    return (
        <div className="grid grid-cols-2 gap-y-6 gap-x-6 bg-gray-bg px-4 py-7 tracking-8 text-black">
            <h3 className="col-span-full font-bold uppercase">
                {[activeStore.storeType, activeStore.town].filter(typedBoolean).join(" ")}
            </h3>
            <div className="col-span-full lg:col-span-1">
                <div className="font-medium">
                    <div>{activeStore.address}</div>
                    <div>{[activeStore.postalCode, activeStore.town].filter(typedBoolean).join(" ")}</div>
                    <a className="underline" href={`tel:${activeStore.phone}`}>{`Tel: ${activeStore.phone}`}</a>
                </div>
                <CheckMarks className="mt-4" store={activeStore} />
            </div>
            <div className="col-span-full lg:col-span-1">
                <Opening store={activeStore} showOpenings />
            </div>
        </div>
    )
}
